import { Snackbar, IconButton, Box, Typography, Stack } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { FloatingNotificationIcon } from 'src/assets/icons/FloatingNotificationIcon';



export const FloatingAlert = ({ open, title, description, onClose, notificationCount, completedJobs = [] }) => {

    return (
        <Snackbar className='notification-popover-component'
            open={open}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            sx={{ marginTop: '40px', zIndex: 9999 }}
            autoHideDuration={6000}
            onClose={onClose}
        >
            <Box className="floating-alert">
                <Box className="alert-box">
                    <Box className="icon-container">
                        <FloatingNotificationIcon />
                    </Box>
                    <Box className="text-container">
                        {completedJobs.length > 0 ? (
                            <Stack spacing={1}>
                                {completedJobs.map((job, index) => (
                                    <Box key={index}>
                                        <Typography className="title d-flex align-items-center">
                                            <span className='mr-1' style={{ fontWeight: 600, color: '#1877f2' }}>{job?.jobId}</span>
                                            <span className='mr-1 f-12' style={{ fontWeight: 500, color: '#1877f2' }}>({job?.cpcType}) -</span>
                                            <span className='f-12'>has been updated successfully</span>
                                        </Typography>
                                    </Box>
                                ))}
                            </Stack>
                        ) : (
                            <>
                                {title && <Typography className="title">
                                    {`${notificationCount} ${title}`}
                                </Typography>}
                                {description && <Typography className="description">
                                    {description}
                                </Typography>}
                            </>
                        )}
                    </Box>
                    <Box className="close-button">
                        <IconButton style={{ padding: '0px' }} aria-label="close" onClick={onClose}>
                            <CancelIcon sx={{ fontSize: '18px', color: '#C5C5C5' }} />
                        </IconButton>
                    </Box>
                </Box>
            </Box>
        </Snackbar>
    );
};
